import { render, staticRenderFns } from "./ShippingRules.vue?vue&type=template&id=0d966412&scoped=true"
import script from "./ShippingRules.vue?vue&type=script&lang=js"
export * from "./ShippingRules.vue?vue&type=script&lang=js"
import style0 from "./ShippingRules.vue?vue&type=style&index=0&id=0d966412&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d966412",
  null
  
)

export default component.exports